import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import { Footer } from "../../components/Footer/Footer";

import { ReactComponent as IconPorcenteNegative } from "../../assets/icons/icon-porcent-negative.svg";
import { ReactComponent as IconPorcentePositive } from "../../assets/icons/icon-porcent-positive.svg";

function OverviewDesktop({ app, config }) {
  const { selections } = useSelections();

  const [currentWeek01, setCurrentWeek01] = useState("");
  const [porcenteWeek01, setPorcenteWeek01] = useState("");
  const [previousWeek01, setPreviousWeek01] = useState();
  const [currentMonth01, setCurrentMonth01] = useState();
  const [previousMonth01, setPreviousMonth01] = useState();

  const [currentWeek02, setCurrentWeek02] = useState("");
  const [porcenteWeek02, setPorcenteWeek02] = useState("");
  const [previousWeek02, setPreviousWeek02] = useState("");
  const [currentMonth02, setCurrentMonth02] = useState();
  const [previousMonth02, setPreviousMonth02] = useState();

  const [currentWeek03, setCurrentWeek03] = useState("");
  const [porcenteWeek03, setPorcenteWeek03] = useState("");
  const [previousWeek03, setPreviousWeek03] = useState();
  const [currentMonth03, setCurrentMonth03] = useState();
  const [previousMonth03, setPreviousMonth03] = useState();

  const [currentWeek04, setCurrentWeek04] = useState("");
  const [porcenteWeek04, setPorcenteWeek04] = useState("");
  const [previousWeek04, setPreviousWeek04] = useState();
  const [currentMonth04, setCurrentMonth04] = useState();
  const [previousMonth04, setPreviousMonth04] = useState();

  const [bigNumber01, setBigNumber01] = useState();
  const [bigNumber02, setBigNumber02] = useState();
  const [bigNumber03, setBigNumber03] = useState();
  const [bigNumber04, setBigNumber04] = useState();

  const getCurrentWeek = useCallback(
    async (objectId, position) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          position === 1 && setCurrentWeek01(value);
          position === 2 && setCurrentWeek02(value);
          position === 3 && setCurrentWeek03(value);
          position === 4 && setCurrentWeek04(value);
        });
      }
    },
    [app]
  );

  const getporcenteWeek = useCallback(
    async (objectId, position) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          position === 1 && setPorcenteWeek01(value);
          position === 2 && setPorcenteWeek02(value);
          position === 3 && setPorcenteWeek03(value);
          position === 4 && setPorcenteWeek04(value);
        });
      }
    },
    [app]
  );

  const getpreviousWeek = useCallback(
    async (objectId, position) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          position === 1 && setPreviousWeek01(value);
          position === 2 && setPreviousWeek02(value);
          position === 3 && setPreviousWeek03(value);
          position === 4 && setPreviousWeek04(value);
        });
      }
    },
    [app]
  );

  const getCurrentMonth = useCallback(
    async (objectId, position) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          position === 1 && setCurrentMonth01(value);
          position === 2 && setCurrentMonth02(value);
          position === 3 && setCurrentMonth03(value);
          position === 4 && setCurrentMonth04(value);
        });
      }
    },
    [app]
  );

  const getpreviousMonth = useCallback(
    async (objectId, position) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          position === 1 && setPreviousMonth01(value);
          position === 2 && setPreviousMonth02(value);
          position === 3 && setPreviousMonth03(value);
          position === 4 && setPreviousMonth04(value);
        });
      }
    },
    [app]
  );

  const getBigNumber = useCallback(
    async (objectId, position) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qDataPages[0]?.qMatrix[0][0]?.qText;
          position === 1 && setBigNumber01(value);
          position === 2 && setBigNumber02(value);
          position === 3 && setBigNumber03(value);
          position === 4 && setBigNumber04(value);
        });
      }
    },
    [app]
  );

  useEffect(() => {
    if (app) {
      getCurrentWeek("PPsnp", 1);
      getporcenteWeek("NgbE", 1);
      getpreviousWeek("gyztTzp", 1);
      getCurrentMonth("Muudedg", 1);
      getpreviousMonth("eQNpxmE", 1);

      getCurrentWeek("BZNjFM", 2);
      getporcenteWeek("pUSkYfu", 2);
      getpreviousWeek("FZSUD", 2);
      getCurrentMonth("uvAPpbe", 2);
      getpreviousMonth("NNSJJP", 2);

      getCurrentWeek("tbDGhfE", 3);
      getporcenteWeek("QzPq", 3);
      getpreviousWeek("VgDkd", 3);
      getCurrentMonth("SXVNrsh", 3);
      getpreviousMonth("SdmAkUH", 3);

      getCurrentWeek("busv", 4);
      getporcenteWeek("NJetT", 4);
      getpreviousWeek("sXjETJa", 4);
      getCurrentMonth("rumAVG", 4);
      getpreviousMonth("ffggdG", 4);
    }
  }, [
    app,
    getCurrentWeek,
    getpreviousWeek,
    getporcenteWeek,
    getCurrentMonth,
    getpreviousMonth,
    selections,
  ]);

  useEffect(() => {
    if (app) {
      getBigNumber("HUVbaW", 1);
      getBigNumber("PsprVEH", 2);
      getBigNumber("pXPMySf", 3);
      getBigNumber("VjqvGk", 4);
    }
  }, [app, getBigNumber, selections]);

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutWrapper>
          <Grid
            container
            flexDirection={"column"}
            justifyContent={"flex-start"}
            rowGap={2}
          >
            {/* Título */}
            <Grid>
              <Card className="container-card-title">
                <h1 className="title">Scorecard 3PD | Visitas</h1>
              </Card>
            </Grid>

            {/* BigNumber kpis 1, 2, 3 and 4 */}
            <Grid container className="container-bigNumbers">
              <Card
                app={app}
                header={{
                  hardTitle: "Call compliance",
                }}
                className={"card-bigNumbers"}
              >
                <p className="title-card">% de Call compliance</p>
                <p>
                  <span className="porcent-bignumber">{bigNumber01}</span>
                </p>
              </Card>

              <Card
                app={app}
                header={{
                  hardTitle: "Média de efetividade",
                }}
                className={"card-bigNumbers"}
              >
                <p className="title-card">% Média de visitas efetivas</p>
                <p>
                  <span className="porcent-bignumber">{bigNumber02}</span>
                </p>
              </Card>

              <Card
                app={app}
                header={{
                  hardTitle: "Média de efetividade DR",
                }}
                className={"card-bigNumbers"}
              >
                <p className="title-card">% Média de visitas efetitvas DR</p>
                <p>
                  <span className="porcent-bignumber">{bigNumber03}</span>
                </p>
              </Card>

              <Card
                app={app}
                header={{
                  hardTitle: "Rotas ativas",
                }}
                className={"card-bigNumbers"}
              >
                <p className="title-card">Rotas que estão ativas</p>
                <p>
                  <span className="porcent-bignumber">{bigNumber04}</span>
                </p>
              </Card>
            </Grid>

            {/* cards visitas with grafs kpis 5, 6, 7 and 8*/}
            <Grid container className="container-bigNumbers-grafs">
              <Card
                app={app}
                header={{
                  hardTitle: "Visitas Programadas",
                }}
                className={"card-bigNumbers-grafs card-bigNumbers-graf-01"}
              >
                <div className="container-line-current-week">
                  <div className="info-current-week">
                    <span className="object-number-week">{currentWeek01}</span>
                    <span className="text-current-week">
                      Período atual: {currentMonth01}
                    </span>
                  </div>

                  <div
                    className={
                      parseInt(porcenteWeek01) > 24
                        ? "info-porcent info-porcent-positive"
                        : "info-porcent info-porcent-negative"
                    }
                  >
                    <span className="icon-arrows">
                      {parseInt(porcenteWeek01) > 24 ? (
                        <IconPorcentePositive />
                      ) : (
                        <IconPorcenteNegative />
                      )}
                    </span>
                    <span className="porcent-info">{porcenteWeek01}</span>
                  </div>
                </div>

                <div className="line-previous-week line-previous-week-01">
                  <span className="objetc-number-previos-week">
                    {previousWeek01}
                  </span>
                  <span className="text-current-week">
                    Período anterior: {previousMonth01}
                  </span>
                </div>

                <div className="legends-grafs legends-graf-01">
                  <p className="container-item-current">
                    <span className="item-color" />
                    <span className="item-text">{currentMonth01}</span>
                  </p>

                  <p className="container-item-preview">
                    <span className="item-color" />
                    <span className="item-text">{previousMonth01}</span>
                  </p>
                </div>

                <NativeObject
                  app={app}
                  key="NNBkjGJ"
                  reference={{ id: "NNBkjGJ" }}
                  style={{
                    width: "100%",
                    height: "200px",
                  }}
                />
              </Card>

              <Card
                app={app}
                header={{
                  hardTitle: "Visitas realizadas",
                }}
                className={"card-bigNumbers-grafs card-bigNumbers-graf-02"}
              >
                <div className="container-line-current-week">
                  <div className="info-current-week">
                    <span className="object-number-week">{currentWeek02}</span>
                    <span className="text-current-week">
                      Período atual: {currentMonth02}
                    </span>
                  </div>

                  <div
                    className={
                      parseInt(porcenteWeek02) > 24
                        ? "info-porcent info-porcent-positive"
                        : "info-porcent info-porcent-negative"
                    }
                  >
                    <span className="icon-arrows">
                      {parseInt(porcenteWeek02) > 24 ? (
                        <IconPorcentePositive />
                      ) : (
                        <IconPorcenteNegative />
                      )}
                    </span>
                    <span className="porcent-info">{porcenteWeek02}</span>
                  </div>
                </div>

                <div className="line-previous-week line-previous-week-02">
                  <span className="objetc-number-previos-week">
                    {previousWeek02}
                  </span>
                  <span className="text-current-week">
                    Período anterior: {previousMonth02}
                  </span>
                </div>

                <div className="legends-grafs legends-graf-01">
                  <p className="container-item-current">
                    <span className="item-color" />
                    <span className="item-text">{currentMonth02}</span>
                  </p>

                  <p className="container-item-preview">
                    <span className="item-color" />
                    <span className="item-text">{previousMonth02}</span>
                  </p>
                </div>

                <NativeObject
                  app={app}
                  key="HJZQRF"
                  reference={{ id: "HJZQRF" }}
                  style={{
                    width: "100%",
                    height: "200px",
                  }}
                />
              </Card>

              <Card
                app={app}
                header={{
                  hardTitle: "Visitas realizadas DR",
                }}
                className={"card-bigNumbers-grafs card-bigNumbers-graf-03"}
              >
                <div className="container-line-current-week">
                  <div className="info-current-week">
                    <span className="object-number-week">{currentWeek03}</span>
                    <span className="text-current-week">
                      Período atual: {currentMonth03}
                    </span>
                  </div>

                  <div
                    className={
                      parseInt(porcenteWeek03) > 24
                        ? "info-porcent info-porcent-positive"
                        : "info-porcent info-porcent-negative"
                    }
                  >
                    <span className="icon-arrows">
                      {parseInt(porcenteWeek03) > 24 ? (
                        <IconPorcentePositive />
                      ) : (
                        <IconPorcenteNegative />
                      )}
                    </span>
                    <span className="porcent-info">{porcenteWeek03}</span>
                  </div>
                </div>

                <div className="line-previous-week line-previous-week-03">
                  <span className="objetc-number-previos-week">
                    {previousWeek03}
                  </span>
                  <span className="text-current-week">
                    Período anterior: {previousMonth03}
                  </span>
                </div>

                <div className="legends-grafs legends-graf-01">
                  <p className="container-item-current">
                    <span className="item-color" />
                    <span className="item-text">{currentMonth03}</span>
                  </p>

                  <p className="container-item-preview">
                    <span className="item-color" />
                    <span className="item-text">{previousMonth03}</span>
                  </p>
                </div>

                <NativeObject
                  app={app}
                  key="NsGXjt"
                  reference={{ id: "NsGXjt" }}
                  style={{
                    width: "100%",
                    height: "200px",
                  }}
                />
              </Card>

              <Card
                app={app}
                header={{
                  hardTitle: "Visitas efetivas totais",
                }}
                className={"card-bigNumbers-grafs card-bigNumbers-graf-04"}
              >
                <div className="container-line-current-week">
                  <div className="info-current-week">
                    <span className="object-number-week">{currentWeek04}</span>
                    <span className="text-current-week">
                      Período atual: {currentMonth04}
                    </span>
                  </div>

                  <div
                    className={
                      parseInt(porcenteWeek04) > 24
                        ? "info-porcent info-porcent-positive"
                        : "info-porcent info-porcent-negative"
                    }
                  >
                    <span className="icon-arrows">
                      {parseInt(porcenteWeek04) > 24 ? (
                        <IconPorcentePositive />
                      ) : (
                        <IconPorcenteNegative />
                      )}
                    </span>
                    <span className="porcent-info">{porcenteWeek04}</span>
                  </div>
                </div>

                <div className="line-previous-week line-previous-week-04">
                  <span className="objetc-number-previos-week">
                    {previousWeek04}
                  </span>
                  <span className="text-current-week">
                    Período anterior: {previousMonth04}
                  </span>
                </div>

                <div className="legends-grafs legends-graf-01">
                  <p className="container-item-current">
                    <span className="item-color" />
                    <span className="item-text">{currentMonth04}</span>
                  </p>

                  <p className="container-item-preview">
                    <span className="item-color" />
                    <span className="item-text">{previousMonth04}</span>
                  </p>
                </div>

                <NativeObject
                  app={app}
                  key="vnsQns"
                  reference={{ id: "vnsQns" }}
                  style={{
                    width: "100%",
                    height: "200px",
                  }}
                />
              </Card>
            </Grid>

            {/* Cards grafs kpis 9, 10 and 11 */}
            <Grid container className="container-graphs">
              <Card
                app={app}
                header={{
                  hardTitle: "Frequência de visita",
                }}
                className={"card-graphs card-graphs-01"}
              >
                {/* <div className="legends-grafs legends-graf-01">
                  <p className="container-item-current">
                    <span className="item-color" />
                    <span className="item-text">{currentMonth04}</span>
                  </p>

                  <p className="container-item-preview">
                    <span className="item-color" />
                    <span className="item-text">{previousMonth04}</span>
                  </p>
                </div> */}

                <NativeObject
                  app={app}
                  key="hCrytQj"
                  reference={{ id: "hCrytQj" }}
                  style={{
                    width: "100%",
                    height: "200px",
                  }}
                />
              </Card>

              <Card
                app={app}
                header={{
                  hardTitle: "Visita/Dia",
                }}
                className={"card-graphs card-graphs-01"}
              >
                <div className="legends-grafs legends-graf-01">
                  <p className="container-item-current">
                    <span className="item-color" />
                    <span className="item-text">{currentMonth04}</span>
                  </p>

                  <p className="container-item-preview">
                    <span className="item-color" />
                    <span className="item-text">{previousMonth04}</span>
                  </p>
                </div>

                <NativeObject
                  app={app}
                  key="cJDyq"
                  reference={{ id: "cJDyq" }}
                  style={{
                    width: "100%",
                    height: "200px",
                  }}
                />
              </Card>

              <Card
                app={app}
                header={{
                  hardTitle: "Cumprimento da rota",
                }}
                className={"card-graphs card-graphs-01"}
              >
                <div className="legends-grafs legends-graf-01">
                  <p className="container-item-current">
                    <span className="item-color" />
                    <span className="item-text">{currentMonth04}</span>
                  </p>

                  <p className="container-item-preview">
                    <span className="item-color" />
                    <span className="item-text">{previousMonth04}</span>
                  </p>
                </div>

                <NativeObject
                  app={app}
                  key="AshzRJ"
                  reference={{ id: "AshzRJ" }}
                  style={{
                    width: "100%",
                    height: "200px",
                  }}
                />
              </Card>
            </Grid>

            <Footer app={app} />
          </Grid>
        </LayoutWrapper>
      </div>
    </div>
  );
}

OverviewDesktop.defaultProps = {
  app: null,
  config: {},
};

OverviewDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OverviewDesktop;
